<script setup>
defineProps({
  btnBackground: {
    type: String,
    default: "",
  },
  isBlur: {
    type: String,
    default: "",
  },
  darkMode: {
    type: Boolean,
    default: false,
  },
  isBtn: { type: String, default: "bg-gradient-light" },
  currentTitleDiy:{
    type: String,
    default: "",
  }
});

const currentTitle = process.env['VUE_APP_TITLE'] || "site.primaryName"


</script>
<template>
  <!-- Navbar -->
  <nav
    class="navbar navbar-expand-lg top-0 z-index-3 position-absolute mt-4"
    :class="isBlur ? isBlur : 'shadow-none my-2 navbar-transparent w-100'"
  >
    <div v-if="currentTitle === 'site.primaryName'" class="container ps-2 pe-0">
      <router-link
        class="navbar-brand font-weight-bolder ms-lg-0 ms-3"
        :class="darkMode ? 'text-black' : 'text-white'"
        to="/"
        >{{currentTitleDiy||$t(currentTitle)}} {{$t('site.name')}}</router-link
      >
      <button
        class="shadow-none navbar-toggler ms-2"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navigation"
        aria-controls="navigation"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="mt-2 navbar-toggler-icon">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </span>
      </button>
      <div class="collapse navbar-collapse" id="navigation">
        <ul class="navbar-nav mx-auto">
          <li class="nav-item">
            <a class="nav-link me-2"
               :href="$t('navbar.businessCaseUrl')"
               target="_blank"
            >
              <i
                class="fa fa-chart-pie opacity-6 me-1"
                aria-hidden="true"
                :class="isBlur ? 'text-dark' : 'text-white'"
              ></i>
              {{$t('navbar.businessCaseName')}}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link me-2"
               :href="$t('navbar.businessConsultingUrl')"
               target="_blank"
            >
              <i
                  class="fa fa-user opacity-6 me-1"
                  aria-hidden="true"
                  :class="isBlur ? 'text-dark' : 'text-white'"
              ></i>
              {{$t('navbar.businessConsultingName')}}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link me-2"
               :href="$t('navbar.aboutUsNameUrl')"
               target="_blank">
              <i
                  class="fas fa-comments opacity-6 me-1"
                  aria-hidden="true"
                  :class="isBlur ? 'text-dark' : 'text-white'"
              ></i>
              {{$t('navbar.aboutUsName')}}
            </a>
          </li>
        </ul>
        <ul class="navbar-nav d-lg-block d-none">
          <li class="nav-item">
            <a
                :href="$t('navbar.productCenterNameUrl')"
                class="btn btn-sm mb-0 me-1"
                :class="isBtn"
                target="_blank"
            >{{$t('navbar.productCenterName')}}</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div v-else class="container ps-2 pe-0">
      <router-link
          class="navbar-brand font-weight-bolder ms-lg-0 ms-3"
          :class="darkMode ? 'text-black' : 'text-white'"
          to="/"
      >{{$t(currentTitle)}} {{$t('site.name')}}</router-link
      >
      <button
          class="shadow-none navbar-toggler ms-2"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navigation"
          aria-controls="navigation"
          aria-expanded="false"
          aria-label="Toggle navigation"
      >
        <span class="mt-2 navbar-toggler-icon">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </span>
      </button>
      <div class="collapse navbar-collapse" id="navigation">
        <ul class="navbar-nav mx-auto">
          <li class="nav-item">
            <a class="nav-link me-2"
               href="https://www.yantaisensor.com/"
               target="_blank"
            >
              <i
                  class="fa fa-chart-pie opacity-6 me-1"
                  aria-hidden="true"
                  :class="isBlur ? 'text-dark' : 'text-white'"
              ></i>
              {{$t('navbar.businessCaseName')}}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link me-2"
               href="https://www.yantaisensor.com/Contact"
               target="_blank"
            >
              <i
                  class="fa fa-user opacity-6 me-1"
                  aria-hidden="true"
                  :class="isBlur ? 'text-dark' : 'text-white'"
              ></i>
              {{$t('navbar.businessConsultingName')}}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link me-2"
               href="https://www.yantaisensor.com/About-us"
               target="_blank">
              <i
                  class="fas fa-comments opacity-6 me-1"
                  aria-hidden="true"
                  :class="isBlur ? 'text-dark' : 'text-white'"
              ></i>
              {{$t('navbar.aboutUsName')}}
            </a>
          </li>
        </ul>
        <ul class="navbar-nav d-lg-block d-none">
          <li class="nav-item">
            <a
                href="https://www.yantaisensor.com/Products"
                class="btn btn-sm mb-0 me-1"
                :class="isBtn"
                target="_blank"
            >{{$t('navbar.productCenterName')}}</a
            >
          </li>
        </ul>
      </div>
    </div>

  </nav>
  <!-- End Navbar -->
</template>
